// Авторизация
import Auth from './auth';
// Справочники
import Catalogs from './catalogs';
// Юридические лица
import LegalEntities from './legal-entities';
// Физические лица
import IndividualPerson from './individual-person';
// Охотничьи билеты
import HuntingTickets from './hunting-tickets';
// Заявления на выдачу охотбилетов
import HuntingTicketOrder from './hunting-ticket-orders';
// Заявления на аннулирование охотбилетов
import HuntingTicketAnnulmentOrder from './hunting-ticket-annulment-orders';
// Администрирование
import AdministrationSection from './administration';
// Охотничий надзор
import HuntingSupervision from './hunting-supervision';
// Печать
import Prints from './print';
// Помощь
import Help from './help';

import HuntingLicenses from './hunting-licenses';
import ResourceQueue from '@/config/routers/resource-queue';

/* LAYOUTS */
const MainLayout = () => import(/* webpackChunkName: "MainLayout" */ 'RootDir/layouts/MainLayout.vue');
const AuthLayout = () => import(/* webpackChunkName: "AuthLayout" */ 'RootDir/layouts/AuthLayout.vue');
/* END LAYOUTS */

/* DUMB COMPONENTS */
// Тупой компонент в котором только вложен router-view
const RouterViewComponent = () => import(
  /* webpackChunkName: "RouterViewComponent" */ 'RootDir/shared_components/RouterViewComponent.vue'
);
/* END DUMB COMPONENTS */

// Главная страница при заходе в систему
const Main = () => import(/* webpackChunkName: "Main" */ 'RootDir/modules/Main.vue');

// Профиль пользователя
const UserProfile = () => import(/* webpackChunkName: "Main" */ 'RootDir/modules/Profile/Index.vue');

// Страница не найдена
const NotFound = () => import(/* webpackChunkName: "NotFound" */ 'RootDir/modules/Errors/NotFound.vue');
const InProcess = () => import(/* webpackChunkName: "NotFound" */ 'RootDir/shared_components/InProcess.vue');

export const routes = [
  {
    path: '/',
    component: MainLayout,
    redirect: { name: 'main' },
    children: [
      {
        path: 'main',
        name: 'main',
        component: Main,
      },
      {
        path: 'in-process',
        name: 'in-process',
        component: InProcess,
      },
      {
        path: 'individual-person',
        name: '',
        component: RouterViewComponent,
        children: IndividualPerson,
      },
      {
        path: 'legal-entities',
        name: '',
        component: RouterViewComponent,
        children: LegalEntities,
      },
      {
        path: 'hunting-ticket-orders',
        name: '',
        component: RouterViewComponent,
        children: HuntingTicketOrder,
      },
      {
        path: 'hunting-tickets',
        name: '',
        component: RouterViewComponent,
        children: HuntingTickets,
      },
      {
        path: 'hunting-ticket-annulment-orders',
        name: '',
        component: RouterViewComponent,
        children: HuntingTicketAnnulmentOrder,
      },
      {
        path: 'limiting-resource-queue',
        name: '',
        component: RouterViewComponent,
        children: ResourceQueue,
      },
      {
        path: 'hunting-supervision',
        name: '',
        component: RouterViewComponent,
        children: HuntingSupervision,
      },
      {
        path: 'hunting-licenses',
        name: 'hunting-licenses',
        component: RouterViewComponent,
        children: HuntingLicenses,
      },
      {
        path: 'catalogs',
        name: '',
        component: RouterViewComponent,
        children: Catalogs,
      },
      {
        path: 'prints',
        name: '',
        component: RouterViewComponent,
        children: Prints,
      },
      {
        path: 'helps',
        name: '',
        component: RouterViewComponent,
        children: Help,
      },
      {
        path: '/administration',
        component: RouterViewComponent,
        children: AdministrationSection,
      },
      {
        path: 'profile',
        name: 'user-profile',
        component: UserProfile,
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: Auth,
  },

  {
    path: '*',
    component: NotFound,
    redirect: '/',
  },
];

export const VueRouterObject = {
  routes,
  mode: 'history',
  saveScrollPosition: true,
  linkActiveClass: 'active',
  transitionOnLoad: true,
};

export default (VueRouter) => new VueRouter(VueRouterObject);
